module.exports = __webpack_public_path__ + "img/touzi-service.c10b904b.png";